
  
    if($('#totalCount').text() == ''){
   $('.total_price').hide(); 
  }else{
    $('.total_price').show();
  }

  var $sqft = $('#Quantity_sqft');
 
   
  var $qty = $('#Quantity');
  var $totalCount = $('#totalCount');
  var $cover_ = parseFloat($('.cover-val').text());
  console.log('cover_ =>'+$cover_);
  if ($cover_ != '1'){
    var $cover = $cover_;
  }
  else{
    var $cover = 1;
  }
  console.log('cover+++ =>'+$cover);
  var $price = $('#ProductPrice').attr('content');
  
  $sqft.on('keypress keyup blur change',function(){
    if($(this).val() != ''){
      var $thisVal = parseFloat($(this).val());
      var count = Math.ceil($thisVal / $cover);
      
      $qty.val(count);
      console.log(count);
      var qty_ = $qty.val();
      if($qty.val() == '1'){
        var qty_ = $('#Quantity_sqft').val();
        $qty.val(qty_);
      }
                  
      $totalCount.text('£'+(parseFloat(qty_) * parseFloat($price) ).toFixed(2) );
      $('.total_price').show();
    }
  });
  $qty.on('keypress keyup blur change',function(){
    if($(this).val() != ''){
      var $thisVal = parseFloat($(this).val());
      var count = $thisVal * $cover;
      $sqft.val(count.toFixed(2));
      $totalCount.text('£'+(parseFloat($qty.val()) * parseFloat($price)).toFixed(2));
      $('.total_price').show();      
    }
  });
  
  
    $('.extra-info .calculator').on('click', function(e){
    
  	$('#cboxContent.CalcularBox').fadeIn();
    $('body').addClass('calc-overlay');
  });
  $('#cboxClose').on('click', function(e){    
    $('#cboxContent.CalcularBox').fadeOut();   
    $('body').removeClass('calc-overlay');
  });
  $('#cboxCloseRecommended').on('click', function(e){   
    $('body').removeClass('calc-overlay');
    $('#cboxContent.recommendedBox').fadeOut();
  });
  
  $('#calculator-footage-section input').on('click',function(e){
    $('#calculator-dimensions-section').addClass('light-overlay');
    $('#calculator-footage-section').removeClass('light-overlay');  	
  });
  $('#calculator-dimensions-section input').on('click',function(e){
    $('#calculator-dimensions-section').removeClass('light-overlay');
    $('#calculator-footage-section').addClass('light-overlay');  	
  });
  $('#calculator-footage-section button#footage-calculate').on('click',function(e){
    
   
//     console.log($cover);
    
    $('#calculator-dimensions-section').addClass('light-overlay');
    $('#calculator-footage-section').removeClass('light-overlay');
    if($('#calculator-footage-section input').val() != ''){
      var $input = parseFloat($('#calculator-footage-section input').val());
      var count = Math.round($input / $cover);
      var mainTotal = Math.round((count/10) + 1) + count;
//       console.log(mainTotal);    
      $('.results').show();
      $('.base-units').text(count);
      $('.total-units').text(mainTotal);
    }else{
      $('#calculator-footage-section input').addClass('error-box');
    }
    
  });
  function calcDimension(lengthIn,widthIn,lengthft,widthft){
    var $lengthIn = 0, $widthIn = 0, $lengthft = 0, $widthft = 0;
    lengthIn.val() != '' ? $lengthIn = parseInt(lengthIn.val())/12 : $lengthIn = 0;
    widthIn.val() != '' ? $widthIn = parseInt(widthIn.val())/12 : $widthIn = 0;    
    lengthft.val() != '' ? $lengthft = parseInt(lengthft.val()) : $lengthft = 0;
    widthft.val() != '' ? $widthft = parseInt(widthft.val()) : $widthft = 0;
    var $totalLength = $lengthIn + $lengthft;
    var $totalWidth = $widthIn + $widthft;
    var count = Math.round(($totalLength * $totalWidth) / $cover);
    
//     console.log(count);
    
    var mainTotal = Math.round((count/10) + 1) + count;
    $('.results').show();
    $('.base-units').text(count);
    $('.total-units').text(mainTotal);
  }
  
  
  $('#calculator-dimensions-section button#dimensions-calculate').on('click',function(e){
    $('#calculator-dimensions-section').removeClass('light-overlay');
    $('#calculator-footage-section').addClass('light-overlay');
    var $lengthIn = 0, $widthIn = 0, $lengthft = 0, $widthft = 0;
    var lengthIn = $('#calculator-length-in'), widthIn = $('#calculator-width-in'), lengthft = $('#calculator-length-ft'), widthft = $('#calculator-width-ft');
    if(lengthIn.val() !== '' && widthIn.val() != '' && lengthft.val() != '' && widthft.val() != ''){      
      calcDimension(lengthIn,widthIn,lengthft,widthft);      
    }else{
      $('#calculator-dimensions-section input').addClass('error-box');
      if(lengthIn.val() != '' || lengthft.val() != ''){
        lengthIn.removeClass('error-box');
        lengthft.removeClass('error-box');
        calcDimension(lengthIn,widthIn,lengthft,widthft);
      }else{
        lengthIn.addClass('error-box');
        lengthft.addClass('error-box');
      }
      if(widthIn.val() != '' || widthft.val() != ''){
        widthIn.removeClass('error-box');
        widthft.removeClass('error-box');
        calcDimension(lengthIn,widthIn,lengthft,widthft);
      }else{
        widthIn.addClass('error-box');
        widthft.addClass('error-box');
      }      
    }  
//     console.log($lengthIn +'---------' + $widthIn);
  });
  
  $('#calculator-add').on('click',function(e){
  	$qty.val(parseInt($('.total-units').text()));
    $('#cboxClose').trigger('click');
    $sqft.trigger('change');
    $qty.trigger('change');
  });
  $('#recommendedCheckbox').on('change',function(e){
    if($(this).prop('checked') == true){
      $('#cboxContent.recommendedBox').fadeIn();
      $('body').addClass('calc-overlay');
    }
  });
  $('[data-recommenedbtn]').on('click',function(e){
    $('body').removeClass('calc-overlay');
    $('#cboxContent.recommendedBox').fadeOut();
  });
  $('#recommended_qty').on('keypress keyup blur', function(e){
    if($(this).val() != '' || $(this).val() != 0){
      $('#recommendedCheckbox').attr('data-qty',$(this).val());
    }else{
      $('#recommendedCheckbox').attr('data-qty',1);
    }
  	//console.log($(this).val());
  });
  
  
  
    $('[data-sample-prd-btn]').on('click',function(e){

    e.preventDefault();
    $(this).addClass('btn--loading');
    var varId = '';
    if($('.pdp_sample__l .swatch-element').length > 0){
      varId = $('[data-sample-div] input:checked').attr('data-value');
    }
    else{
      varId = $('.variant_id').data('value');
    }
    var qty = 1;
    var data_ajax = {
      "quantity": qty,
      "id": varId
    }
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: data_ajax,
      dataType: 'json'
    };
    $.ajax(params);  
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
      //$('.CartCount').text(cart.item_count);
      
      var $cartContainer = '#CartContainer';
      
      cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
      };

      buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
          $cartContainer.append(
            '<p class="cart--empty-message">' +
            theme.strings.cartEmpty +
            '</p>\n' +
            '<p class="cookie-message">' +
            theme.strings.cartCookies +
            '</p>'
          );
          cartCallback(cart);
          return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $('#CartTemplate').html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
          /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
          var prodImg;
          var unitPrice = null;
          if (cartItem.image !== null) {
            prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, '_small$1')
            .replace('http:', '');
          } else {
            prodImg =
              '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          if (cartItem.properties !== null) {
            $.each(cartItem.properties, function(key, value) {
              if (key.charAt(0) === '_' || !value) {
                delete cartItem.properties[key];
              }
            });
          } 

          if (cartItem.properties !== null) {
            $.each(cartItem.properties, function(key, value) {
              if (key.charAt(0) === '_' || !value) {
                delete cartItem.properties[key];
              }
            });
          }

          if (cartItem.line_level_discount_allocations.length !== 0) {
            for (var discount in cartItem.line_level_discount_allocations) {
              var amount =
                  cartItem.line_level_discount_allocations[discount].amount;

              cartItem.line_level_discount_allocations[
                discount
              ].formattedAmount = theme.Currency.formatMoney(
                amount,
                settings.moneyFormat
              );
            }
          }

          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              var cartAmount =
                  cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

              cart.cart_level_discount_applications[
                cartDiscount
              ].formattedAmount = theme.Currency.formatMoney(
                cartAmount,
                settings.moneyFormat
              );
            }
          }
 
          if (cartItem.unit_price_measurement) {
            unitPrice = {
              addRefererenceValue:
              cartItem.unit_price_measurement.reference_value !== 1,
              price: theme.Currency.formatMoney(
                cartItem.unit_price,
                settings.moneyFormat
              ),
              reference_value: cartItem.unit_price_measurement.reference_value,
              reference_unit: cartItem.unit_price_measurement.reference_unit
            };
          } 

          // Create item's data object and add to 'items' array
          item = {
            key: cartItem.key,
            line: index + 1, // Shopify uses a 1+ index in the API
            url: cartItem.url,
            img: prodImg,
            name: cartItem.product_title,
            variation: cartItem.variant_title,
            sellingPlanAllocation: cartItem.selling_plan_allocation,
            properties: cartItem.properties,
            itemAdd: cartItem.quantity + 1,
            itemMinus: cartItem.quantity - 1,
            itemQty: cartItem.quantity,
            price: theme.Currency.formatMoney(
              cartItem.original_line_price,
              settings.moneyFormat
            ),
            discountedPrice: theme.Currency.formatMoney(
              cartItem.final_line_price,
              settings.moneyFormat
            ),
            discounts: cartItem.line_level_discount_allocations,
            discountsApplied:
            cartItem.line_level_discount_allocations.length === 0 ? false : true,
            vendor: cartItem.vendor,
            unitPrice: unitPrice
          };
 
          items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
          items: items,
          note: cart.note,
          totalPrice: theme.Currency.formatMoney(
            cart.total_price,
            settings.moneyFormat
          ),
          cartDiscounts: cart.cart_level_discount_applications,
          cartDiscountsApplied:
          cart.cart_level_discount_applications.length === 0 ? false : true
        };

        $cartContainer.append(template(data));

        cartCallback(cart);
      };

      cartCallback = function(cart) {
        $('body').removeClass('drawer--is-loading');
        $('body').trigger('ajaxCart.afterCartLoad', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      };
      
    });
     
    setTimeout(function(){
      $('[data-sample-prd-btn]').removeClass('btn--loading');
      $(document).find('.js-drawer-open-button-right').trigger('click')
    },1500);

//     jQuery(document.body).on('afterGetCart.ajaxCart', function(evt, cart) {
//       timber.cartUpdatePopup(cart);
//     });
  });
  
